import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import Range from './Range';

export default class RangeCollection extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = {
            range: null,
        };

        this.state = {
            value: props?.value ?? 0,
            items: props?.collection,
        };
    }

    static get propTypes() {

        return {
            collection: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
            value: PropTypes.any,
            prefix: PropTypes.any,
            suffix: PropTypes.any,
            onChange: PropTypes.func,
        };
    }

    render() {

        const items = this.getItems();
        if (items.length < 1)
            return null;

        return (
            <div className={ style('flex flex-wrap w-full justify-between') }>
                <Range
                    ref={ (node) => { this.nodes.range = node; } }
                    className={ style('w-full') }
                    min={ 0 }
                    max={ items.length - 1 }
                    value={ parseInt(this.state.value) }
                    onChange={ (e) => this.changeEvent(e) }
                    />
                <div className={ style('text-muted') }>{ this.props.prefix }</div>
                <div className={ style('text-muted') }>{ this.props.suffix }</div>
            </div>
        );
    }

    setValue(value) {

        this.setState({ value });
    }

    getItems() {

        return this.props.collection
            ? Object.values(this.props.collection)
            : [];
    }

    changeEvent(e) {

        const { target } = e;
        this.state.value = target.value;

        if (this.props.onChange != undefined) {

            const
                value = target.value,
                selected = this.getItems()[value];

            this.props.onChange(new CustomEvent('change', { detail: {
                target,
                value,
                selected,
            } }));
        }
    }

}